export const getTextColor = (backgroundColor) => {
    if (!backgroundColor || backgroundColor === 'rainbow') return "white";

    try {
        let r, g, b;

        // ======== MISSING RGB EXTRACTION CODE ========
        if (backgroundColor.startsWith('#')) {
            const hex = backgroundColor.replace('#', '').trim();
            let hexPairs;
            
            if (hex.length === 3) {
                hexPairs = hex.split('').map(c => c + c);
            } else if (hex.length === 6) {
                hexPairs = [hex.substr(0, 2), hex.substr(2, 2), hex.substr(4, 2)];
            } else {
                return '#ffffff'; // Fallback for invalid HEX
            }

            r = parseInt(hexPairs[0], 16);
            g = parseInt(hexPairs[1], 16);
            b = parseInt(hexPairs[2], 16);
        } else if (backgroundColor.startsWith('rgb')) {
            const rgbValues = backgroundColor.match(/\d+/g);
            if (!rgbValues || rgbValues.length < 3) return '#ffffff';
            
            r = parseInt(rgbValues[0], 10);
            g = parseInt(rgbValues[1], 10);
            b = parseInt(rgbValues[2], 10);
        } else {
            return '#ffffff'; // Fallback for unknown formats
        }
        // ======== END OF MISSING CODE ========

        const [h, s, l] = rgbToHsl(r, g, b);
        
        // Color generation logic remains the same
        if (l < 30) {
            return hslToHex(h, Math.min(s * 1.2, 100), Math.min(l + 65, 90));
        }
        if (l < 50) {
            return hslToHex(h, Math.min(s * 1.1, 95), l + 45);
        }
        if (l < 75) {
            return hslToHex(h, Math.min(s * 1.1, 95), l - 35);
        }
        return hslToHex(h, Math.min(s * 1.2, 100), l - 50);
    } catch (error) {
        console.error('Error calculating text color:', error);
        return '#ffffff';
    }
};
// RGB to HSL conversion
const rgbToHsl = (r, g, b) => {
    // Replace comma-separated assignments with separate statements
    r /= 255;
    g /= 255;
    b /= 255;

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h = 0; // Initialize h to avoid undefined
    let s, l = (max + min) / 2;

    if (max === min) {
        h = s = 0;
    } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r: 
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g: 
                h = (b - r) / d + 2;
                break;
            case b: 
                h = (r - g) / d + 4;
                break;
            default:
                h = 0; // Safety net
        }
        h /= 6;
    }
    return [h * 360, s * 100, l * 100];
};

// HSL to HEX conversion
const hslToHex = (h, s, l) => {
    h /= 360;
    s /= 100;
    l /= 100;
    
    let r, g, b;
    if (s === 0) {
        r = g = b = l;
    } else {
        const hue2rgb = (p, q, t) => {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1/6) return p + (q - p) * 6 * t;
            if (t < 1/2) return q;
            if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
            return p;
        };
        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }
    
    const toHex = x => {
        const hex = Math.round(x * 255).toString(16);
        return hex.length === 1 ? '0' + hex : hex;
    };
    
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};